/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/models/user.model';
import { CustomPaginationService } from 'src/services/custom-pagination.service';
import { OciService } from 'src/services/oci.service';
import { UserService } from 'src/services/user.service';
import { ModalEventEnum } from 'src/types';
import { LocalStorageService } from '../local-storage.service';
import { Page } from '../page';
import { PreviewDocumentComponent } from '../sidebar-widget/preview-document/preview-document.component';

@Component({
   selector: 'app-profile',
   templateUrl: './profile.component.html',
   styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent {
   pageEvaluation: Page<any> = new Page();
   loggedIn: User;
   currentCenter: string;
   workerId: any;
   object: any = {
      document: '',
      action: '',
      subjectId: '',
      message: '',
      title: '',
   };

   constructor(
      public translate: TranslateService,
      private localStorageService: LocalStorageService,
      public dialog: MatDialog,
      private paginationService: CustomPaginationService,
      private userService: UserService,
      private ociService: OciService,
   ) {
      this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
      this.loggedIn.roles = this.userService.getUserRoleTitle(JSON.parse(this.localStorageService.get('loggedUser')).role);
      this.localStorageService.set('localStorageCenterId', this.loggedIn?.csrId);

      this.currentCenter = this.loggedIn.city;
      this.userService.findUserData(this.loggedIn.id).subscribe(res => {
         this.workerId = res.id;
         this.findDocumentsByWorker();
      });
   }

   public findDocumentsByWorker() {
      const filter = {
         minDate: '',
         maxDate: '',
         text: [],
      };
      if (this.pageEvaluation.numberOfElements === 1 && this.pageEvaluation.pageable.pageNumber !== 0) {
         this.pageEvaluation.pageable.pageNumber = this.pageEvaluation.pageable.pageNumber - 1;
      }

      this.ociService.getWorkerDocuments(this.workerId, this.pageEvaluation.pageable, filter).subscribe(result => {
         this.pageEvaluation = result;
         for (const element of this.pageEvaluation.content) {
            element.dateOfModification = element.dateOfModification.split(' ')[0] + '. ' + element.dateOfModification.split(' ')[1];
         }
         this.pageEvaluation.pageable.pagePerShow = result.number + 1;
      });
   }

   public getNextPageEvaluation(): void {
      this.pageEvaluation.pageable = this.paginationService.getNextPage(this.pageEvaluation);
      this.findDocumentsByWorker();
   }

   public getPreviousPageEvaluation(): void {
      this.pageEvaluation.pageable = this.paginationService.getPreviousPage(this.pageEvaluation);
      this.findDocumentsByWorker();
   }

   public getFirstPageEvaluation(): void {
      this.pageEvaluation.pageable = this.paginationService.getFirstPage(this.pageEvaluation);
      this.findDocumentsByWorker();
   }

   public getLastPageEvaluation(): void {
      this.pageEvaluation.pageable = this.paginationService.getLastPage(this.pageEvaluation);
      this.findDocumentsByWorker();
   }

   public getPageInNewSizeEvaluation(pageSize: any): void {
      this.pageEvaluation.pageable = this.paginationService.getPageInNewSize(this.pageEvaluation, pageSize);
      this.findDocumentsByWorker();
   }

   openDialog(action: 'view' | 'cancel' | 'download' | 'print', obj: any) {
      this.object.document = obj;
      this.object.action = action;

      if (action === ModalEventEnum.VIEW) {
         const dialogRef = this.dialog.open(PreviewDocumentComponent, {
            panelClass: 'overlay-panel',
            disableClose: true,
            data: this.object,
         });

         dialogRef.afterClosed().subscribe(() => {});
      } else if (action === ModalEventEnum.DOWNLOAD) {
         this.ociService.downloadDocument(obj.documentId, obj.name, obj.format);
      } else if (action === ModalEventEnum.PRINT) {
         this.ociService.printDocument(obj.documentId, obj.name);
      }
   }
}
